import { Shuffle } from 'lucide-react';
import './ShuffleButton.css';

type Props = {
    active: boolean;
    onClick: () => void;
};

export function ShuffleButton({ active, onClick }: Props) {
    return (
        <button
            className={`shuffleButton ${active ? 'shuffleButtonActive' : ''}`}
            onClick={onClick}
            aria-label="Toggle shuffle"
            aria-pressed={active}
        >
            <Shuffle size={16} strokeWidth={2.75} />
        </button>
    );
}
